// Pure cooldown helpers, kept free of imports with browser-only side effects
// (veloConstants throws outside the browser) so they stay unit-testable.
export const STORAGE_KEY = 'vp_mobile_promo_banner_shown'
export const COOLDOWN_DAYS = 7

export function hasCooldownExpired(
  storageKey: string = STORAGE_KEY,
  cooldownDays: number = COOLDOWN_DAYS,
): boolean {
  try {
    const lastShown = localStorage.getItem(storageKey)
    if (!lastShown) {
      return true
    }

    const lastShownTime = new Date(lastShown).getTime()
    if (Number.isNaN(lastShownTime)) {
      return true
    }

    const daysSinceShown = (Date.now() - lastShownTime) / (1000 * 60 * 60 * 24)
    return daysSinceShown >= cooldownDays
  } catch {
    return true
  }
}

export function markBannerAsShown(storageKey: string = STORAGE_KEY): void {
  try {
    localStorage.setItem(storageKey, new Date().toISOString())
  } catch {
    // localStorage unavailable (private mode etc.) — banner may show again sooner
  }
}
